export const action1 = ({ commit }) => {
  commit("something");
};

export const action2 = ({ commit }) => {
  commit("something");
};
